<template>
  <div class="formmake">
    <el-button size="small" v-for="(item, index) in list" @click="tab(index)" :loading="nowIndex == index" class="mt10">{{ item.name }}</el-button>
    <div class="align-center mt10">
      <template v-if="list.length">
        <div>表单名字：</div>
        <el-input v-model="list[nowIndex].name" style="width: 250px;margin-right: 20px"></el-input>
        <div>表单标识：</div>
        <el-input v-model="list[nowIndex].title" style="width: 250px;"></el-input>
      </template>
      <div class="flex1"></div>
      <div>
        <el-button type="primary" @click="add">新增</el-button>
        <el-button type="primary" @click="sub">保存</el-button>
        <el-button type="danger" @click="del">删除</el-button>
      </div>
    </div>
    <fm-making-form class="mt20" ref="makingform" style="height: 700px;" preview generate-code generate-json clearable upload> </fm-making-form>

    <!-- <el-link href="http://docs.form.making.link/components.html" target="_blank" class="mt20">查看文档</el-link> -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      title: '',
      name: '',
      nowIndex: 0,
    };
  },
  mounted() {
    this.$get(location.origin + '/api/getForm?' + Date.now()).then((res) => {
      this.list = res || [];

      if (this.list.length) {
        if (this.list[this.nowIndex].data) {
          this.$refs.makingform.setJSON(this.list[this.nowIndex].data);
        } else {
          this.$refs.makingform.handleClear();
        }
      }
    });
  },
  methods: {
    add() {
      this.$refs.makingform.handleClear();
      this.list.push({ title: '', name: '', data: null });
      this.nowIndex = this.list.length - 1;
    },
    sub() {
      let data = { data: this.$refs.makingform.getJSON(), title: this.list[this.nowIndex].title, name: this.list[this.nowIndex].name };
      this.list[this.nowIndex] = data;
      this.save();
    },
    save() {
      this.$post(location.origin + '/api/saveForm', this.list).then((res) => {
        this.$message({ 
          message: "修改成功", 
          type: "success", 
          duration: 700,});
      });
    },
    tab(index) {
      this.nowIndex = index;
      this.title = this.list[index].title;
      this.name = this.list[index].name;
      if (this.list[this.nowIndex].data) {
        this.$refs.makingform.setJSON(this.list[this.nowIndex].data);
      } else {
        this.$refs.makingform.handleClear();
      }
    },
    del() {
      this.list.splice(this.nowIndex, 1);
      this.nowIndex = 0;
      this.save();
    },
  },
};
</script>

<style lang="scss">
.formmake {
  padding: 20px 40px;
  .btn-bar {
    .el-button {
      color: #fff;
    }
  }
}
</style>
